module.exports = __webpack_public_path__ + "img/rock-huge-07.cccbe431.png";